import currentTab from './modules/store'

export const modules = {
  currentTab
}



// WEBPACK FOOTER //
// ./src/store/ActiveTabs/index.js